import { isUnDef } from 'utils/tool.js'

export const genCustomFonts = function (num, className = '') {
  if (isUnDef(num)) num = 0
  return `<span class="bb-num ${className}">${num}</span>`
}

export const userInfoShowAllStat = function (showall) {
  // 展开全部埋点
  if (showall) {
    this.$trackEvent('newprofilepages_moreintro', {})
  }
}
